import http from '@/utils/http'
//根据店铺名称获得数据
export function getRestaurantByName(params){
  return http.get('/api/takeawayRestaurant/getRestaurantByName',params)
}
export function getRestaurantById(params){
  return http.get('/api/takeawayRestaurant/getRestaurantById',params)
}
export function getRestaurantByTakeawayUrl(params){
  return http.get('/api/takeawayRestaurant/getRestaurantByTakeawayUrl',params)
}
export function getTakeawayFoodTypeList(params){
  return http.get('/api/takeaway/getTakeawayFoodTypeList',params)
}

export function getTakeawayFoodList(params){
  return http.get('/api/takeaway/getTakeawayFoodList',params)
}

export function getFoodCustomAttributeList(params){
  return http.get('/api/takeaway/getFoodCustomAttributeList',params)
}

export function getFood(params){
  return http.get('/api/takeaway/getFood',params)
}
export function getConfigs(params){
  return http.get('/api/takeawayRestaurant/getConfigs',params)
}
export function getRestaurantBankById(params){
  return http.get('/api/takeawayRestaurant/getRestaurantBankById',params)
}
export function getCustomerByPhone(params){
  return http.get('/api/takeawayRestaurant/getCustomerByPhone',params)
}
export function getZCode(params){
  return http.get('/api/takeawayRestaurant/getZCode',params)
}

export function getSpecialtimeSet(params){
  return http.get('/api/takeawayRestaurant/getSpecialtimeSet',params)
}

export function getOrderMain(params){
  return http.get('/api/takeaway/getOrderMain',params)
}

export function getOrderList(params){
  return http.get('/api/takeaway/getOrderList',params)
}

export function saveBookTable(params){
  return http.post('/api/takeawayRestaurant/saveBookTable',params)
}

export function orderTakeAwayList(params){
  return http.post('/api/takeaway/orderTakeAwayList',params)
}

export function getRestaurantLinkById(params){
  return http.get('/api/takeaway/getRestaurantLinkById',params)
}
export function getRestaurantLinkByCustomeId(params){
  return http.get('/api/takeaway/getRestaurantLinkByCustomeId',params)
}
export function updatecCustomerSend(params){
  return http.post('/api/takeaway/updatecCustomerSend',params)
}
export function updatecCustomerUnSend(params){
  return http.post('/api/takeaway/updatecCustomerUnSend',params)
}
export function onlinePayment(params){
  return http.post('/api/takeaway/onlinePayment',params)
}
export function getOnlinePaymentResult(params){
  return http.get('/api/takeaway/getOnlinePaymentResult',params)
}
export function getAllTakeawayFoodList(params){
  return http.get('/api/takeaway/getAllTakeawayFoodList',params)
}

export function addContact(params){
  return http.post('/api/takeaway/addContact',params)
}

export function getCouponListByBusId(params){
  return http.get('/api/takeaway/getCouponListByBusId',params)
}

export function getShortUrlById(params){
  return http.get('/api/takeaway/getShortUrlById',params)
}

export function registerCustomer(params){
  return http.post('/api/takeawayUser/registerCustomer',params)
}

export function loginCustomer(params){
  return http.post('/api/takeawayUser/loginCustomer',params)
}

export function saveUserCustomer(params){
  return http.post('/api/takeawayUser/saveUserCustomer',params)
}

export function getCustomerById(params){
  return http.get('/api/takeawayUser/getCustomerById',params)
}

export function getFoodRecommendList(params){
  return http.get('/api/takeaway/getFoodRecommendList',params)
}

export function getMyOrderList(params){
  return http.get('/api/takeaway/getMyOrderList',params)
}
export function getCaptcha(params){
  return http.get('/api/takeawayUser/getCaptcha',params)
}
export function forgetPassword(params){
  return http.post('/api/takeawayUser/forgetPassword',params)
}
export function resetPassword(params){
  return http.post('/api/takeawayUser/resetPassword',params)
}